import { Navigate, createFileRoute } from '@tanstack/react-router';
import { Forbidden, Loading } from '@/components/shared/page-states.js';
import { useSession } from '@/features/auth/session.js';

/**
 * The app root opens the first page the user may see, in menu order
 * (cash-deposits.md section 10).
 */
const LANDING_PAGES = [
  { service: 'DEPOSIT_LIST', to: '/deposits' },
  { service: 'DEPOSIT_CREATE', to: '/deposits/new' },
  { service: 'DEPOSIT_DELIVER', to: '/deliver' },
  { service: 'DEPOSIT_RETURN', to: '/deliver' },
  { service: 'USER_LIST', to: '/settings/users' },
  { service: 'GROUP_LIST', to: '/settings/groups' },
] as const;

export const Route = createFileRoute('/_app/')({
  component: LandingRedirect,
});

function LandingRedirect(): React.JSX.Element {
  const session = useSession();
  if (session.isPending) return <Loading />;
  const services = session.data?.services ?? [];
  const landing = LANDING_PAGES.find((page) => services.includes(page.service));
  if (!landing) return <Forbidden />;
  return <Navigate to={landing.to} replace />;
}
